import React from 'react';

export const STATUS_OPTIONS = [
  { value: 'received', label: 'Received', color: '#2b6cb0', bg: '#ebf4ff' },
  { value: 'quote_sent', label: 'Quote Sent', color: '#805ad5', bg: '#f3ebff' },
  { value: 'in_progress', label: 'In Progress', color: '#b7791f', bg: '#fffaf0' },
  { value: 'completed', label: 'Completed', color: '#2f855a', bg: '#f0fff4' },
  { value: 'cancelled', label: 'Cancelled', color: '#c53030', bg: '#fff5f5' }
];

export const statusMeta = (status) => STATUS_OPTIONS.find((s) => s.value === status) || STATUS_OPTIONS[0];

export const StatusBadge = ({ status }) => {
  const meta = statusMeta(status);
  return (
    <span data-testid={`status-badge-${meta.value}`} style={{ display: 'inline-block', padding: '0.25rem 0.7rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: '700', color: meta.color, backgroundColor: meta.bg, border: `1px solid ${meta.color}33` }}>
      {meta.label}
    </span>
  );
};
